import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import VasApi from './VasAPI'
import Cookies from 'js-cookie'

const IN_TWO_HOURS = new Date(new Date().getTime() + 120 * 60 * 1000);
function getSessionID () {
  try {
    const fromSession = Cookies.get('SESSION_ID')
    if (fromSession) {
      return Number(fromSession)
    }
    return Math.floor(Math.random() * 10)  
  } catch (error) {
    return Math.floor(Math.random() * 10)  
  }
}
export class TinabaAPI {
  static instance: TinabaAPI;
  static sessionId = getSessionID()
  private readonly $request!: AxiosInstance;
  public readonly $vas!: VasApi;

  constructor () {
    if (TinabaAPI.instance) return TinabaAPI.instance
    this.$request = axios.create({
      baseURL: process.env.VUE_APP_TINABA_API_BASE || 'https://api.valid.tinaba.it/',
    })

    this.$vas = new VasApi(this)
    this.saveSessionID()

    TinabaAPI.instance = this
    return TinabaAPI.instance
  }

  saveSessionID () {
    try {
      if (TinabaAPI.sessionId) {
        Cookies.set('SESSION_ID', `${TinabaAPI.sessionId}`, { expires: IN_TWO_HOURS })
      }
    } catch (error) {
      
    }
  }

  get isProduction () {
    return true
    // return process.env.NODE_ENV === 'production'
  }

  public static install (Vue: any, options = {}) {
    Vue.prototype.$tinabaAPI = new TinabaAPI();
    return Vue
  }

  async request (config: AxiosRequestConfig) {
    try {
      if (!this.isProduction) {
        console.log('################################')
        console.log('Making Request', config);
      }

      const { data } = await this.$request(config)

      if (!this.isProduction) {
        console.log('Request Succeeded', data);
        console.log('################################')
      }
      return data
    } catch (error) {
      if (!this.isProduction) {
        console.error('Request Error', error.toJSON(), error)
        console.log('################################')
      }
      throw error.response
    }
  }
}

export default TinabaAPI